import { productState } from 'Config/constants'

export const getTotalPrice = products => products?.map(({ total }) => total)?.reduce((a, b) => a + b, 0)

export const hasAvailableProduct = cart =>
  cart &&
  Object.keys(cart).find(item => cart[item].state === productState.ok || cart[item].state === productState.changePrice)
